
export const IMPRESSUM_TEXT = `
# Impressum

## Angaben gemäß § 5 TMG / § 5 DDG

**Waldhotel Bad Essen UG (haftungsbeschränkt)**  
Bergstraße 51  
49152 Bad Essen

**Vertreten durch:**  
Geschäftsführerin: Mariya Düselder

**Kontakt:**  
Telefon: +49 176 3241 9623  
E-Mail: kontakt@waldhotel-badessen.de

**Registereintrag:**  
Registergericht: Amtsgericht Osnabrück  
Handelsregisternummer: HRB 222377

**Umsatzsteuer-ID:**  
Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE457980375

**Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV:**  
Mariya Düselder  
Bergstraße 51  
49152 Bad Essen

## EU-Streitschlichtung
Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr.
Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.

## Haftung für Inhalte
Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG / DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG / DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.

## Haftung für Links
Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.

## Urheberrecht
Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
`;

export const DATENSCHUTZ_TEXT = `
# Datenschutzerklärung

## 1. Verantwortliche Stelle
Verantwortlich für die Datenverarbeitung auf dieser Website ist:

**Waldhotel Bad Essen UG (haftungsbeschränkt)**  
Geschäftsführerin: Mariya Düselder  
Bergstraße 51  
49152 Bad Essen  
Telefon: +49 176 3241 9623  
E-Mail: kontakt@waldhotel-badessen.de

## 2. Hosting und Server-Logs
Diese Website wird bei einem externen Hosting-Anbieter gehostet. Beim Besuch unserer Website werden automatisch Informationen in sogenannten Server-Log-Dateien gespeichert (Browsertyp, IP-Adresse, Referrer-URL etc.). Die Erfassung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.

## 3. SSL-Verschlüsselung
Diese Seite nutzt aus Sicherheitsgründen eine SSL-Verschlüsselung (https://).

## 4. Cookies
Unsere Website verwendet Cookies.
**Essenzielle Cookies:** Notwendig für den Betrieb.
**Funktionale/Analyse-Cookies:** Nur mit Ihrer Einwilligung.
Sie können Ihre Cookie-Einstellungen jederzeit ändern.

## 5. Kontaktaufnahme
Bei Kontaktaufnahme per E-Mail oder Formular werden Ihre Angaben zwecks Bearbeitung gespeichert (Art. 6 Abs. 1 lit. b DSGVO).

## 6. Ihre Rechte
Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch (Art. 15-21 DSGVO).

## 7. Beschwerderecht
Sie haben das Recht, sich bei der zuständigen Aufsichtsbehörde zu beschweren (Die Landesbeauftragte für den Datenschutz Niedersachsen).
`;
